import React from 'react';
import styles from '../layout/AdminLayout.module.css';

const LectureRegisterComponent: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <div>
        <b className={styles.pageTitle}>강의 등록</b>
      </div>
      
      <div className={styles.pageContent}>
        <p>강의 등록 기능을 구현해주세요.</p>
      </div>
    </div>
  );
};

export default LectureRegisterComponent;
